import React from "react";

export default function SectionDivider({ label }) {
  return (
    <div
      className="section-divider"
      style={{
        display: "flex",
        alignItems: "center",
        margin: "18px 0",
      }}
    >
      <hr
        style={{
          flex: 1,
          border: "none",
          borderTop: "1px solid #ccc",
        }}
      />
      <span
        style={{
          padding: "0 10px",
          fontWeight: "600",
          color: "#444",
          fontSize: "14px",
          whiteSpace: "nowrap",
        }}
      >
        {label ? label : ""}
      </span>
      <hr
        style={{
          flex: 1,
          border: "none",
          borderTop: "1px solid #ccc",
        }}
      />
    </div>
  );
}
